import { HEADER_HEIGHT } from "@/constants/components";
import { useGetServerTime } from "@/hooks/useGetServerTime";

import { Switch } from "@chakra-ui/react";
import { css } from "@emotion/react";
import { Lottie } from "@toss/lottie";
import { colors, getCookie, HStack, VStack } from "goi_common";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { usePatchSangjoQuotationRequestAcceptNightCall } from "./hooks/usePatchSangjoQuotationRequestAcceptNightCall";

const DEFAULT_TEXTS = [
  <>
    궁금한 내용을
    <br />
    부담없이 물어보세요
  </>,
  <>
    더 나은 서비스를
    <br />
    훨씬 더 합리적으로 이용하도록
    <br />
    고객님과 함께해요
  </>,
  <>
    전화상담은 장례준비의 핵심이에요.
    <br />
    부담없이 전화해보세요
  </>,
  <>
    장례지도사님이
    <br />
    24시간 대기중이에요.
    <br />이 순간부터 장지까지 함께해드려요.
  </>,
];

// const CAPITAL_LIST = ["11", "31", "23"]; //서울, 경기, 인천

function MatchRequestCompleteContainer() {
  const router = useRouter();
  const { id } = router.query;
  const quotationResponse = getCookie("quotation-request") || null;

  const [acceptNightCall, setAcceptNightCall] = useState(true);
  const [textIndex, setTextIndex] = useState(0);

  /** 서버시간 기준 야간인 경우 */
  const { data } = useGetServerTime();

  /** 임박이 아닌 경우 */
  const isNotImminent = !quotationResponse?.status?.includes("임종");
  const isShowNightCallToggle = data?.is_night && isNotImminent;

  const { mutate: patchAcceptNightCall } = usePatchSangjoQuotationRequestAcceptNightCall(
    String(id),
    acceptNightCall,
  );

  useEffect(() => {
    const totalTime = 6000;
    const intervalTime = totalTime / DEFAULT_TEXTS.length;

    const intervalId = setInterval(() => {
      setTextIndex((prev) => {
        if (prev >= DEFAULT_TEXTS.length - 1) return DEFAULT_TEXTS.length - 1;
        return prev + 1;
      });
    }, intervalTime);

    setTimeout(() => {
      clearInterval(intervalId);
      patchAcceptNightCall();
    }, totalTime);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  if (!router.isReady) return null;

  return (
    <>
      <VStack
        padding="0px 20px"
        alignItems="center"
        justifyContent="center"
        css={[rootCss, { height: `calc(var(--vh, 1vh) * 100 - ${HEADER_HEIGHT}px)` }]}
      >
        <>
          <div css={textCss.container}>
            {DEFAULT_TEXTS.map((text, index) => (
              <div
                key={index}
                className="head2_b gray900 font-center"
                css={[textCss.self, { opacity: index === textIndex ? 1 : 0 }]}
              >
                {text}
              </div>
            ))}
          </div>

          <div css={lottie1Css}>
            <Lottie src="/lotties/LOADING-1.json" width="100px" height="100px" loop={true} />
          </div>
          <Lottie src="/lotties/LOADING-2.json" width="245px" loop={true} />
        </>
        {isShowNightCallToggle && (
          <HStack css={acceptCallCss}>
            <VStack margin="0px 36px 0px 0px">
              <div className="button gray700">야간 전화 수신 동의</div>
              <div className="caption1 gray400">빠른 맞춤형 상담을 위해 전화를 드릴 수 있어요.</div>
            </VStack>
            <Switch
              css={chakraSwitchCss}
              size="lg"
              isChecked={acceptNightCall}
              onChange={() => setAcceptNightCall((oldState) => !oldState)}
            />
          </HStack>
        )}
      </VStack>
    </>
  );
}

const rootCss = css({
  paddingBottom: "35.96vh",
});
const lottie1Css = css({
  height: "20px",
});

const textCss = {
  container: css({
    width: "100%",
    position: "relative",
  }),
  self: css({
    position: "absolute",
    transition: "0.5s opacity",
    bottom: 0,
    left: 0,
    right: 0,
  }),
};

const acceptCallCss = css({
  backgroundColor: colors.gray50,
  padding: "14px 16px 14px 20px",

  maxWidth: "420px",
  width: "100%",
  height: "72px",

  borderRadius: "10px",
  alignItems: "center",
  justifyContent: "space-between",
});

const chakraSwitchCss = css({
  ".chakra-switch__track[data-checked]": {
    background: colors.orange650,
  },
});

export default MatchRequestCompleteContainer;
